import { setIntersection, AllSameKeyValuesEnforcer, AllSameKeysEnforcer } from '../helpers/helpers'
import { WorkforceGroup, WFWorker } from './workforce.data';
import { LabelObject } from './events.data';
import { FiltersGroupingUI } from './filters-ui.models';
export interface FilterGroupGroups {
  accounts?: string[]
  activityLabels?: string[]
  assetLabels?: string[]
  closed?: boolean
  createdBy?: string[]
  days?: string[] // of the form id:[day number], for example, [programId]:[programDay]
  entityIds?: string[]
  eventLabels?: string[]
  exhibitorLabels?: string[]
  exhibitors?: string[]
  flagged?: string
  groupTags?: string[] // names
  groupVisibilities?: string[]
  me?: boolean
  myResponsibility?: boolean
  myEvents?: boolean
  performerLabels?: string[]
  performers?: string[] // performer Id -> can be used to filter against "performer tags" (in activities or possibly elsewhere) and "performers" (in sessions).  These are one and the same 
  programLabels?: string[]
  programs?: string[]
  responsibilities?: string[]
  schedules?: string[]
  search?: string
  sessionLabels?: string[]
  sessions?: string[]
  sponsorLabels?: string[]
  sponsors?: string[]
  standalones?: string[]
  tags?: string[] // email
  types?: string[] // asset types for now
  categories?: string[]
  taskLabels?: string[]
  visibilities?: string[]
  workforce?: boolean
  resources?: string[]
  resourceLabels?: string[]
  attendeeLabels?: string[]
  attendees?: string[]

}


// This is defined separately for internal consistency with dictionary making below
export interface FilterGroupTypes {
	programTimeline: FilterGroup
	programTimelineSnapshot: FilterGroup
	programLogistics: FilterGroup
	onsiteTimeline: FilterGroup
	onsiteFacilitators: FilterGroup
  onsiteMySchedule: FilterGroup
  onsiteShare: FilterGroup
  performersTable: FilterGroup
  performerSessionsTable: FilterGroup
  tasks: FilterGroup
  tasksTable: FilterGroup
	tasksCalendar: FilterGroup
  tasksSidebar: FilterGroup
  performerTasks: FilterGroup
  myTasks: FilterGroup
  home: FilterGroup
  publish: FilterGroup
  eventList: FilterGroup
  performerBrief: FilterGroup
  resources: FilterGroup
  sponsors: FilterGroup
  sponsor_sessions: FilterGroup
  exhibitors: FilterGroup
  exhibitor_stands: FilterGroup
  exhibitor_brief: FilterGroup
  taskTime: FilterGroup
  allTasks: FilterGroup
  allTasksCalendar: FilterGroup
  allEventsCalendar: FilterGroup
  allTemplatesTable: FilterGroup
  asset_table: FilterGroup
  quotes: FilterGroup
  accountQuotes: FilterGroup
  programTable: FilterGroup
  budgets: FilterGroup
  appTable: FilterGroup
  app: FilterGroup
  attendees: FilterGroup
}

export interface IToggleFilter {
	condensed: boolean,
	sortByDate: boolean,
	hideCompleted: boolean
}

export interface FiltersState extends FilterGroupTypes {
	tempCounts: AllSameKeysEnforcer<FilterGroupTypes>
	toggleFilters: AllSameKeysEnforcer<FilterGroupTypes>
	lastLoadedFilterUI: { filterGroupType: string, UIModel: FiltersGroupingUI[] } // Please note: this is not meant to be a faithful representation of the current filter UI, as its selected and disabled states are not dispatched through state.  It is meant, instead, to just show the overall model itself.
	onsiteFiltersByDateMap: Record<string, FilterGroup>
	onsiteFilterDates: Set<String>
}



export const filterPageTypes: AllSameKeyValuesEnforcer<FilterGroupTypes> = { 
  home: 'home', onsiteFacilitators: 'onsiteFacilitators', 
  onsiteMySchedule: 'onsiteMySchedule', onsiteShare: 'onsiteShare', 
  programTimeline: 'programTimeline', programLogistics: 'programLogistics',
  onsiteTimeline: 'onsiteTimeline', tasks: 'tasks', tasksTable:'tasksTable', 
  tasksSidebar: 'tasksSidebar', myTasks: 'myTasks', tasksCalendar: 'tasksCalendar', 
  programTimelineSnapshot: 'programTimelineSnapshot', 
  performersTable: 'performersTable', publish: 'publish', 
  performerSessionsTable: 'performerSessionsTable', 
  exhibitor_brief: 'exhibitor_brief', performerBrief: 'performerBrief', 
  exhibitor_stands: 'exhibitor_stands', sponsors: 'sponsors', 
  sponsor_sessions: 'sponsor_sessions', taskTime: 'taskTime', 
  exhibitors: 'exhibitors', eventList: 'eventList', allTasks: 'allTasks', 
  allTasksCalendar: 'allTasksCalendar', allEventsCalendar: 'allEventsCalendar', 
  performerTasks: 'performerTasks', allTemplatesTable: 'allTemplatesTable', 
  asset_table: 'asset_table', resources: 'resources', quotes: 'quotes', 
  accountQuotes: 'accountQuotes', budgets: 'budgets', 
  programTable: 'programTable', appTable: 'appTable', app: 'app', 
  attendees: 'attendees' }
export type FilterType = keyof typeof filterPageTypes

export const toggleFilterTypes: AllSameKeyValuesEnforcer<IToggleFilter> = { condensed: 'condensed', sortByDate: 'sortByDate', hideCompleted: 'hideCompleted' }

export interface Filter {
	id: string,
	name: string,
	selected: boolean
}

interface IFilterCountChanges {
	Increment
	Decrement
	Set
	Reset
}

export const FilterCountChanges: AllSameKeyValuesEnforcer<IFilterCountChanges> = {
	Increment: 'Increment',
	Decrement: 'Decrement',
	Set: 'Set',
	Reset: 'Reset'
}




export interface FilterGroup extends FilterGroupGroups {
  count: number // this is the actual applied filter count, not just the ui one like in tempCounts
}

export const filterTypes: AllSameKeyValuesEnforcer<FilterGroup> = {
  me: 'me', workforce: 'workforce', closed: 'closed', flagged: 'flagged', search: 'search', myResponsibility: 'myResponsibility',
  responsibilities: 'responsibilities', createdBy: 'createdBy', visibilities: 'visibilities',
  groupVisibilities: 'groupVisibilities', programs: 'programs', schedules: 'schedules', sessions: 'sessions', 
  accounts: 'accounts', eventLabels: 'eventLabels', performerLabels: 'performerLabels', 
  programLabels: 'programLabels', sessionLabels: 'sessionLabels', activityLabels: 'activityLabels', 
  sponsorLabels: 'sponsorLabels', taskLabels: 'taskLabels', days: 'days', tags: 'tags', types: 'types',
  performers: 'performers', groupTags: 'groupTags', sponsors: 'sponsors', exhibitors: 'exhibitors', attendees: 'attendees',
  exhibitorLabels: 'exhibitorLabels', entityIds: 'entityIds', count: 'count', myEvents: 'myEvents', assetLabels: 'assetLabels', 
  resources: 'resources', resourceLabels: 'resourceLabels', standalones: 'standalones', categories: 'categories', attendeeLabels: 'attendeeLabels',
}

export const modifyFilters = (filters: FilterGroup, filterKey: string, oldList: string[], newSet: Set<string>) => {
  if (filterKey === filterTypes.count) return
  const newFiltersArray = Array.from(setIntersection(new Set(oldList), newSet))
  if (newFiltersArray.length) {
    filters[filterKey] = newFiltersArray
  } else {
    delete filters[filterKey]
  }
  filters.count -= oldList.length - newFiltersArray.length
}


interface FilterFilterInputs {
  filters: FilterGroup
  workforceGroupsById: { [id: string]: WorkforceGroup }
  workersByEmail: { [key: string]: WFWorker }
  activity_labels?: LabelObject
  asset_labels?: LabelObject
  attendee_labels?: LabelObject
  session_labels: LabelObject
  program_labels: LabelObject
  scheduleIds?: Set<string>
  attendeeIds?: Set<string>
  programIds: Set<string>
  sessionLabels: Set<string>
  programLabels: Set<string>
  activityLabels?: Set<string>
  tags: Set<string>
  dayIds?: Set<string>
  groupTags: Set<string>
  performerIds: Set<string>
  sponsorIds: Set<string>
  sponsor_labels?: LabelObject
  performer_labels?: LabelObject
  sponsorLabels?: Set<string>
  performerLabels?: Set<string>
  exhibitor_labels?: LabelObject
  exhibitorLabels?: Set<string>
  exhibitorIds?: Set<string>
  resourceIds?: Set<string>
  resource_labels?: LabelObject
  resourceLabels?: Set<string>
  attendeeLabels?: Set<string>
  assetLabels?: Set<string>
}


// This is a joint filter filtering function for program publish - share filters and onsite timeline share view filters.  It is also used by firebase functions to filter live data.  The filters need to be filtered because the filters are stale, but the data they are supposed to be filtering is live, and one stale non-existant filter would / should filter out everything.
// NOTE: "performerIds" is actually the ids of the live data, careful
export const filterFilters = ({ filters, workforceGroupsById, workersByEmail, activity_labels, attendee_labels, asset_labels, session_labels, program_labels, 
  scheduleIds, programIds, sessionLabels, programLabels, activityLabels, tags, groupTags, performerIds, sponsorIds, sponsor_labels, 
  sponsorLabels, performer_labels, performerLabels, exhibitorLabels, exhibitor_labels, exhibitorIds, dayIds, resourceIds,
  resource_labels, resourceLabels, attendeeLabels, assetLabels, attendeeIds }: FilterFilterInputs
) => {

  groupTags.forEach(tag => {
    if (!workforceGroupsById[tag]) {
      groupTags.delete(tag)
    }
  })
  tags.forEach(tag => {
    if (!workersByEmail[tag]) {
      tags.delete(tag)
    }
  })
  if (!filters) return

  sessionLabels = setIntersection(sessionLabels, new Set(Object.keys(session_labels)))
  programLabels = setIntersection(programLabels, new Set(Object.keys(program_labels)))

  if (activityLabels && activity_labels) {
    activityLabels = setIntersection(activityLabels, new Set(Object.keys(activity_labels)))
  }

  if (attendeeLabels && attendee_labels) {
    attendeeLabels = setIntersection(attendeeLabels, new Set(Object.keys(attendee_labels)))
  }

  if (assetLabels && asset_labels) {
    assetLabels = setIntersection(assetLabels, new Set(Object.keys(asset_labels)))
  }
  
  if (sponsorLabels && sponsor_labels) {
    sponsorLabels = setIntersection(sponsorLabels, new Set(Object.keys(sponsor_labels)))
  }

  if (resourceLabels && resource_labels) {
    resourceLabels = setIntersection(resourceLabels, new Set(Object.keys(resource_labels)))
  }

  if (exhibitorLabels && exhibitor_labels){
    exhibitorLabels = setIntersection(exhibitorLabels, new Set(Object.keys(exhibitor_labels)))
  }

  if (performerLabels && performer_labels) {
    performerLabels = setIntersection(performerLabels, new Set(Object.keys(performer_labels)))
  }

  Object.entries(filters).forEach(([name, filtered]) => {
    switch (name) {
      case filterTypes.attendeeLabels:
        modifyFilters(filters, name, filtered, attendeeLabels)
        break
      case filterTypes.assetLabels:
        modifyFilters(filters, name, filtered, assetLabels)
        break
      case filterTypes.performers:
        modifyFilters(filters, name, filtered, performerIds)
        break
      case filterTypes.sponsors:
        modifyFilters(filters, name, filtered, sponsorIds)
        break
      case filterTypes.exhibitors:
        modifyFilters(filters, name, filtered, exhibitorIds)
        break
      case filterTypes.resources:
        modifyFilters(filters, name, filtered, resourceIds)
        break
      case filterTypes.attendees:
        modifyFilters(filters, name, filtered, attendeeIds)
        break
      case filterTypes.programs:
        modifyFilters(filters, name, filtered, programIds)
        break
      case filterTypes.days:
        modifyFilters(filters, name, filtered, dayIds)
        break
      case filterTypes.schedules: // if the filters can't have schedules, this won't be hit
        modifyFilters(filters, name, filtered, scheduleIds)
        break
      case filterTypes.resourceLabels:


      case filterTypes.sponsorLabels: // might not be hit
        modifyFilters(filters, name, filtered, sponsorLabels)
        break
      case filterTypes.performerLabels: // might not be hit
        modifyFilters(filters, name, filtered, performerLabels)
        break
      case filterTypes.activityLabels: // if the filters can't have activityLabels, this won't be hit
        // console.log({ filters, name, filtered, activityLabels, activity_labels })
        modifyFilters(filters, name, filtered, activityLabels)
        break
      case filterTypes.programLabels:
        modifyFilters(filters, name, filtered, programLabels)
        break
      case filterTypes.sessionLabels:
        modifyFilters(filters, name, filtered, sessionLabels)
        break
      case filterTypes.exhibitorLabels:
        modifyFilters(filters, name, filtered, exhibitorLabels)
        break
      case filterTypes.tags:
        modifyFilters(filters, name, filtered, tags)
        break
      case filterTypes.groupTags:
        modifyFilters(filters, name, filtered, groupTags)
        break
      default:
        break
    }
  })
}


